import { network } from 'services/network';

export const getLatestProgramDate = (metaDataId: number) => {
    const url = `api/bo/getLatestProgramDate?metaDataId=${metaDataId}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
